import { render, staticRenderFns } from "./LicenseInformationAddEdit.vue?vue&type=template&id=37f36402&scoped=true"
import script from "./LicenseInformationAddEdit.vue?vue&type=script&lang=js"
export * from "./LicenseInformationAddEdit.vue?vue&type=script&lang=js"
import style0 from "./LicenseInformationAddEdit.vue?vue&type=style&index=0&id=37f36402&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f36402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f36402')) {
      api.createRecord('37f36402', component.options)
    } else {
      api.reload('37f36402', component.options)
    }
    module.hot.accept("./LicenseInformationAddEdit.vue?vue&type=template&id=37f36402&scoped=true", function () {
      api.rerender('37f36402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/components/specialist-tab/components/LicenseInformationAddEdit.vue"
export default component.exports